import axios from "axios"
import { useState, useEffect } from "react"
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { RotatingLines } from "react-loader-spinner"

let error = []//array gestione errori insert foto

function EditImg({ numero, folder, imgOld, invioFoto }) {
    const redux = useSelector((state) => state.creaEvento.value)
    const location = useLocation()
    const fromConfirm = location.state?.fromConfirm // 'indietro' da 'confirmEditEvento'

    const [foto, setFoto] = useState([])//foto provenienti da MYSQL o dagli input
    const [msgProgress, setMsgProgress] = useState(null)//esito upload foto 
    const [msg, setMsg] = useState([])

    const numFoto = numero // NUMERO MASSIMO DI FOTO (è l'index nel loop in html) ----------

    function createArrImgOld() {//funzione per visualizzare le foto archiviate in MYSQL
        let arrImg = []; let arrImgName = []; let photo = null
        if (redux.img) { photo = redux.img } else if (imgOld) photo = imgOld
        if (photo) {//se ci sono foto in MYSQL caricale in 'setFoto' per mandarle a schermo
            arrImg = photo.split(',')
            arrImg.forEach((item, index) => {
                arrImgName[index] = { name: item }
            })
        }; return { arrImg: arrImg, arrImgName: arrImgName }
    }
    const oldImg = createArrImgOld()

    const imageChange = async (e) => {
        if (e.target.files[0]) {
            const el = e.target.getAttribute('data-val')//posizione della foto in array 'foto'
            const eT = e.target.files[0]; error = []; setMsg(null)
            if (eT.type.startsWith('image/')) {
                setMsgProgress('Caricamento in corso, attendere...')

                // RINOMINAZIONE FOTO CON NOME RANDOM
                let extens = eT.name.substring(eT.name.lastIndexOf('.') + 1)// ricavo l'estensione
                const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'// prendi questi caratteri per generare la stringa random
                let result = ''
                const charactersLength = characters.length
                for (let i = 0; i < 15; i++) {
                    result += characters.charAt(Math.floor(Math.random() * charactersLength))
                }
                const zxc = `ZE_${result}.${extens}` // aggiungo ZE alla stringa random (+ l'estensione) che darà il nome alla foto

                // ------ ACCETTAZIONE IMMAGINE ----------------------------------------   
                try {
                    const fd = new FormData()
                    const datiFoto = { foto: eT, nomeFoto: zxc, stato: 'siAwsBucket', folder: '' }
                    Object.entries(datiFoto).forEach(([chiave, valore]) => fd.append(chiave, valore))
                    const res = await axios.post('/convertJpegBase64', fd, {
                        headers: { "Content-Type": "multipart/form-data" }
                    })
                    if (res.data === 'success') {
                        setFoto(foto.concat(`ZE_${result}.webp`))//per preview 
                        setMsgProgress(null)
                        document.getElementById('label' + el).style.display = 'none'// tolgo '+foto'
                        el < numFoto.length - 1 && ( //risettaggio input disabled = false
                            document.getElementById('upload-photo' + (parseInt(el) + 1)).disabled = false)
                    } else {
                        document.getElementById('upload-photo' + el).value = ''
                        setMsgProgress('*** problemi con il server...riprova ***')
                    }
                } catch (err) { console.log(err) }
            } else {
                //immagine type non conforme
                error[el] = 'Tipo immagine non conforme'
                setMsg(error)
                e.target.value = ""; return
            }
        }
    }
    const imageRemove = async (e) => {
        setMsg(null); error = []; setMsgProgress(null)
        const el = e.target.getAttribute("data-val")//posizione della foto da eliminare in array 'foto'
        const bj = foto.length - 1
        document.getElementById('upload-photo' + el).value = ''
        function removeFadeOut(elment, speed) {
            let seconds = speed / 300
            elment.style.transition = "opacity " + seconds + "s ease"
            elment.style.opacity = 0
            setTimeout(() => {
                const nj = [...foto]
                nj.splice(el, 1)
                setFoto(nj)
                setTimeout(() => {
                    elment.style.opacity = 1; document.getElementById('label' + bj).style.display = 'block'//visualizzo '+foto'  
                }, 50)
            }, speed)
        }
        try {
            axios.delete(`/delete-img/${foto[el]}`, { data: { folder: '' } })
        } catch (err) { setMsgProgress('*** Problemi con la connessione ***'); console.error(err); return }
        removeFadeOut(document.getElementById('preview' + el), 200)
        removeFadeOut(document.getElementById('iconaElimina' + el), 200)

        //RISETTAGGIO INPUT FOTO = DISABLED
        let index = foto.length - 1
        for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
            if (h > (index + 1)) {
                document.getElementById('upload-photo' + (h - 1)).disabled = true
            }
        }
    }

    useEffect(() => {
        invioFoto(foto)
        if (foto.length !== 0) { // settaggio label dentro il div dell'input delle foto (+foto)
            for (let x = 0; x < foto.length; x++) {
                document.getElementById('label' + x).style.display = 'none'
            }
        }
    }, [foto])

    useEffect(() => {
        let flag // settaggio input foto disabled  
        if (fromConfirm !== true) {// se provengo da editEvento1 setto i disabled degli input con le foto da MYSQL
            setFoto(oldImg.arrImg); flag = oldImg.arrImg.length
        } else
            if (fromConfirm === true) {// se provengo da confirmEditEvento setto i disabled con le foto provenienti da redux
                setFoto(redux.foto); flag = redux.foto.length
            }
        if (flag < numFoto.length - 1) {//settaggio input foto = disabled
            let index = flag
            for (let h = 1; h <= numFoto.length; h++) {//loop di tutti i div contenenti gli input type file
                if (h > (index + 1)) {
                    document.getElementById('upload-photo' + (h - 1)).disabled = true
                }
            }
        }
    }, [])

    return (<>
        <div>
            <h4 style={{ marginTop: '3rem' }}>AGGIUNGI IMMAGINI</h4>
            <p><i>Se aggiungi immagini all'evento otterrai più visualizzazioni</i></p><br />
            <div className='gridAddEvento2'>
                {numFoto.map(elem => (
                    <div key={elem} className='fotoEvento'>
                        <label htmlFor={"upload-photo" + elem} style={{ marginTop: '0px', cursor: 'pointer' }} id={'label' + elem}>
                            {elem === 0 ? <span style={{ fontSize: 'small' }}>+ Foto principale</span> : <span>+foto</span>}
                        </label>
                        {/* preview --------------------------------- */}
                        {foto[elem] &&
                            <div>
                                <div style={{ marginTop: '-24px' }}>
                                    <span style={{ marginLeft: '5rem', cursor: 'pointer' }} data-val={elem}
                                        onClick={imageRemove} id={'iconaElimina' + elem} type='button'>
                                        ❌
                                    </span>
                                </div>
                                <span id={'preview' + elem}>
                                    <img src={`https://leuro-bucket.s3.amazonaws.com/${foto[elem]}`} style={{ maxWidth: '100px', height: '74px' }} alt="" />
                                </span>
                            </div>
                        }
                        {error[elem] &&
                            <p id={'msg' + elem} style={{ fontSize: 'small' }}>{msg[elem]}</p>
                        }
                        <input id={'upload-photo' + elem} style={{ opacity: '0', fontSize: '0px' }}
                            type='file' data-val={elem}
                            name={'foto' + elem}
                            accept="image/*"
                            onChange={imageChange} />
                    </div>
                ))}
            </div>
        </div >
        {msgProgress &&
            <p style={{ color: 'red', marginTop: '1em', fontWeight: '600' }}>
                {msgProgress}
                {msgProgress === 'Caricamento in corso, attendere...' &&
                    <RotatingLines strokeColor='red' strokeWidth='5' animationDuration='5' width='26' />
                }
            </p>
        }
    </>)
}
export default EditImg